import { useEffect, useMemo, useState } from 'react'

import { Button } from '@/components/ui/button.tsx'

import { LoadingSpinner } from '@/components/LoadingSpinner.tsx'
import { useQueryIterations } from '@/requests/queries/useQueryProject.ts'
import { GlobalPubSub } from '@/utils/pubsub.ts'

export const LoadPastIterationsButton = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { iterations } = useQueryIterations()

  const isLoaded = useMemo(() => {
    const [firstIteration] = iterations
    return firstIteration.number === 1
  }, [iterations])

  useEffect(() => {
    isLoaded && setIsLoading(false)
  }, [isLoaded])

  if (isLoaded) return

  if (isLoading) return <LoadingSpinner className="h-5 w-5" />

  return (
    <Button
      type="button"
      variant="ghost"
      onClick={() => {
        setIsLoading(true)
        GlobalPubSub.publish(GlobalPubSub.Signals.TOGGLE_GET_PAST_ITERATIONS, true)
      }}
      disabled={isLoading}
      className="h-6 py-2 px-1 rounded-xs"
    >
      <div className="flex items-center gap-1">
        <p className="font-EN-KR-caption-regular text-contents-primary">Displaying last 4 iterations. Show all</p>
        <img src="/images/entity-add-icon.svg" alt="load more" />
      </div>
    </Button>
  )
}
